import React from 'react';
import InitialiseThirdParties from 'core/InitialiseThirdParties';
import { ThemeProvider } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { Loader } from 'components';
import { DefaultLoadingContainer } from 'components/Loader/Loader.style';
import Router from './Router';
import { useAppVM } from './useAppVM';

const App: React.FunctionComponent = () => {
    const { title, theme, themeCss, error, isError, isLoading } = useAppVM();

    if (isLoading) {
        return (
            <DefaultLoadingContainer>
                <Loader size={50} />
            </DefaultLoadingContainer>
        );
    }

    if (isError && error) {
        // TODO: next PR => Improve display
        return <div>{JSON.stringify(error)}</div>;
    }

    return (
        <div style={{ ...themeCss, height: '100%' }}>
            <Helmet>
                <meta
                    name="theme-color"
                    content={theme.base.color.backgroundBar}
                    data-testId="theme-color"
                />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, maximum-scale=1"
                />
                <title>{title}</title>
            </Helmet>
            <ThemeProvider theme={theme}>
                <Router />
                <InitialiseThirdParties />
            </ThemeProvider>
        </div>
    );
};

export default App;
